<div
  class="vf-dropdown"
  #vfDropdown
  [ngClass]="isWide == true ? 'dropdown-wide' : 'dropdown-simple'"
  data-vf-js-dropdown
>
  <div class="vf-dropdown__label-container">
    <div
      class="vf-dropdown__label"
      [ngClass]="isWide == true ? 'label-wide' : 'label-simple'"
      style="text-align: left"
    >
      Download files
    </div>
    <div [ngClass]="isSvgTop == true ? 'label-simple-pos' : ''">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path 
          d="M7 10.5L12 15.5L17 10.5H7Z" 
          [attr.fill]="isWide ? 'white' : 'black'"
        />
      </svg>
    </div>
    
  </div>

  <div
    class="vf-dropdown__menu-container"
    [ngClass]="isWide == true ? 'container-wide' : 'container-simple'"
  >
    <div class="vf-dropdown-overlay"></div>
    <div class="vf-dropdown__menu">
      <div *ngFor="let data of dropdownOptions" class="vf-dropdown__menu-item">
        
        <div *ngIf="data.isHeader" class="vf-dropdown__menu-header">
          {{ data.label }}
        </div>      
        <a
          *ngIf="data.isShow"
          class="vf-dropdown__menu-item-link"
          [ngClass]="{
            'item-disabled': data.disabled,
            'item-wide': isWide,
            'item-simple': !isWide
          }"
          [ngStyle]="
            data.disabled
              ? { color: 'gray', cursor: 'not-allowed', position: 'relative' }
              : {}
          "
          (mouseenter)="data.disabled && (showTooltip = true)"
          (mouseleave)="showTooltip = false"
          (click)="!data.disabled && select(data.value)"
        >
          {{ data.label }}

          <!-- Custom tooltip -->
          <ng-container *ngIf="data.disabled && showTooltip">
            <div class="custom-tooltip">
              {{ data.disabled ? "Please select entries to download" : "" }}
            </div>
          </ng-container>
        </a>

        <!-- Optional info text below option label -->
        <div
          *ngIf="data.info"
          class="vf-dropdown__menu-item-info"
          [ngClass]="{
            'item-disabled': data.disabled,
            'item-wide': isWide,
            'item-simple': !isWide
          }"
          [ngStyle]="
            data.disabled
              ? { color: 'gray', cursor: 'not-allowed', position: 'relative' }
              : {}
          "
          (mouseenter)="data.disabled && (showTooltip = true)"
          (mouseleave)="showTooltip = false"
        >
          {{ data.info }}
        </div>
        <div *ngIf="data.isWarning">
          <hr class="rule"/>
        </div>
        <div *ngIf="data.isWarning" class="vf-dropdown__menu-warning">
          {{ data.label }}
        </div>   
      </div>
    </div>
  </div>
</div>
